export const IRISH_TRANSLATIONS = {
    text: {
        back: 'ar ais',
        home: 'bhaile',
        search: 'cuardach',
       
    }
};